export const ERROR_TEXT_LIST = {
    INVALID_TIMES: "Las horas son iguales o la hora de inicio es mayor a la de fin.",
};